import DatafieldSection, {
  DatafieldLabel,
} from "../../../components/datafield-section";
import { Payout, RetailODDetails, TermLoanDetails } from "../../../dto";
import { RetailODDrawdownStatusEnum } from "../../../models";
import { dateToDDMMYYYY } from "../../../utils";
import { refactorLoanData } from "../../loan-details/helpers";

interface DisbursalDetailsProps {
  loanDetails?: TermLoanDetails | RetailODDetails | null;
  payoutDetails?: Payout | null;
  isDrawdownLoan?: boolean;
}

const DISBURSAL_DETAILS_LABELS: DatafieldLabel[] = [
  {
    items: [
      {
        label: "Disbursal Date",
        key: ["disbursedOn"],
      },
      {
        label: "Bank Account No.",
        key: ["bankAccountNo", "bankAccountDetails.accountNumber"],
      },
    ],
  },
  {
    items: [
      {
        label: "IFSC",
        key: ["ifscCode", "bankAccountDetails.ifsc"],
      },
      {
        label: "UTR",
        key: "utr",
      },
      {
        label: "Disbursed Amount",
        key: ["disbursedAmount", "disbursalDetails.disbursedAmount"],
        prefix: "Rs",
        formatMethod: (value: number) => value.toFixed(2),
      },
    ],
  },
];

export default function DisbursalDetails({
  loanDetails,
  payoutDetails,
  isDrawdownLoan,
}: DisbursalDetailsProps) {
  if (!payoutDetails && !loanDetails) return null;

  const data = isDrawdownLoan
    ? {
        ...payoutDetails,
        disbursedOn: dateToDDMMYYYY(
          payoutDetails?.statusLog?.find(
            (log) => log.status === RetailODDrawdownStatusEnum.INITIATED,
          )?.updatedAt,
        ),
        disbursedAmount:
          payoutDetails != null
            ? payoutDetails.amount -
              (payoutDetails.processingFeePreGst +
                payoutDetails.gstOnProcessingFee)
            : undefined,
      }
    : refactorLoanData(loanDetails, null, null);

  return (
    <DatafieldSection
      title="Disbursal Details"
      labels={DISBURSAL_DETAILS_LABELS}
      data={data}
    />
  );
}
